"use strict";

exports.__esModule = true;
exports.SECONDS_OF_YEAR = exports.SECONDS_OF_DAY = exports.MILLISECONDS_OF_YEAR = exports.MILLISECONDS_OF_DAY = exports.EXPECTED_BLOCK_TIME_WITH_DELAY = exports.EXPECTED_BLOCK_TIME = void 0;
const MILLISECONDS_OF_DAY = 24 * 60 * 60 * 1000;
exports.MILLISECONDS_OF_DAY = MILLISECONDS_OF_DAY;
const SECONDS_OF_DAY = 24 * 60 * 60;
exports.SECONDS_OF_DAY = SECONDS_OF_DAY;
const MILLISECONDS_OF_YEAR = 365 * MILLISECONDS_OF_DAY;
exports.MILLISECONDS_OF_YEAR = MILLISECONDS_OF_YEAR;
const SECONDS_OF_YEAR = 365 * SECONDS_OF_DAY;
exports.SECONDS_OF_YEAR = SECONDS_OF_YEAR;
const EXPECTED_BLOCK_TIME = 12 * 1000;
exports.EXPECTED_BLOCK_TIME = EXPECTED_BLOCK_TIME;
const EXPECTED_BLOCK_TIME_WITH_DELAY = 12.5 * 1000;
exports.EXPECTED_BLOCK_TIME_WITH_DELAY = EXPECTED_BLOCK_TIME_WITH_DELAY;